import React, {ForwardedRef, forwardRef} from 'react'

import {cn} from '@/src/shared/utils/twMerge'

const Body1 = forwardRef(
  (
    {children, className}: {children: React.ReactNode; className?: string},
    ref: ForwardedRef<HTMLParagraphElement>
  ) => {
    return (
      <p
        ref={ref}
        className={cn(
          'lg:text-3xl text-2xl font-normal text-gray-800 leading-relaxed tracking-normal',
          className
        )}>
        {children}
      </p>
    )
  }
)

Body1.displayName = 'Body1'

export default Body1
